import createSagaMiddleware from '@redux-saga/core'
import { configureStore, Middleware } from '@reduxjs/toolkit'
import {
  abortActionMiddlewareListener,
  authMiddlewareListener,
  otpMiddlewareListener,
} from '@repo/core'
import { requestMiddleware } from '../middlewares/requestsMiddleware'
import { rootReducers } from './reducers'

export const sagaMiddleware = createSagaMiddleware()

interface ConfigureAppStoreParams {
  reducer?: Parameters<typeof configureStore>[0]['reducer']
  middlewares?: Array<Middleware>
}

export const configureAppStore = (params?: ConfigureAppStoreParams) => {
  const { reducer, middlewares = [] } = params || {}
  const appReducer = reducer ? reducer : rootReducers

  const store = configureStore({
    reducer: appReducer,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware().concat([
        sagaMiddleware,
        authMiddlewareListener().middleware,
        otpMiddlewareListener().middleware,
        requestMiddleware,
        abortActionMiddlewareListener().middleware,
        ...middlewares,
      ]),
    devTools: true,
  })

  return { store, sagaMiddleware }
}
